import { ListingFeedResponseSchema, type ListingFeedResponse } from "@kraahl/contract";

/**
 * Listing-feed / search adapter — the single `/api/feed/{listings,recommended}`
 * caller. Keeps `fetch('/api/...')` out of the hook (HARD GATE — CLAUDE.md);
 * the hook builds the query params, this builder picks the endpoint, fetches
 * and parses the response against `@kraahl/contract`. Parse failures pass the
 * raw body through (logged) so a wire-shape drift never breaks the feed.
 */
export async function fetchListingFeed(
  mode: "just-listed" | "discover" | "recommended" | undefined,
  params: URLSearchParams,
  opts?: { signal?: AbortSignal },
): Promise<ListingFeedResponse> {
  const url =
    mode === "recommended"
      ? `/api/feed/recommended?${params.toString()}`
      : `/api/feed/listings?${params.toString()}`;

  const response = await fetch(url, { signal: opts?.signal });
  if (!response.ok) {
    throw new Error(`Failed to fetch: ${response.status}`);
  }

  const json = await response.json();
  const parsed = ListingFeedResponseSchema.safeParse(json);
  if (!parsed.success) {
    console.warn("[search] listing-feed response failed contract parse", parsed.error.issues);
    return json as ListingFeedResponse;
  }
  return parsed.data;
}
